import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { createPayPalCloudSubscription } from '@/utils/cloudApi';
import { isPayPalWebShell } from '@/utils/payPalWebUi';

/** Matches Account card subscribe buttons (Settings). */
export const subscribePrimaryButtonClass =
  'inline-flex w-56 items-center justify-center gap-2 rounded-full px-8 py-4 font-body font-medium whitespace-nowrap transition-all hover:bg-theme-hover hover:-translate-y-0.5 shadow-sm bg-theme-primary text-primary disabled:opacity-50 disabled:hover:translate-y-0';

/**
 * Web-only PayPal subscription entry (must not render in the native shell — App Store / IAP rules).
 * @param {{ hideIntro?: boolean }} [props]
 */
export function WebSubscriptionGate({ hideIntro = false } = {}) {
  const [busy, setBusy] = useState(false);

  if (!isPayPalWebShell()) return null;

  const onSubscribe = async () => {
    setBusy(true);
    try {
      const data = await createPayPalCloudSubscription();
      const url = String(data?.approvalUrl || '').trim();
      if (!url) {
        toast.error('PayPal did not return a checkout link. Try again or contact support.');
        return;
      }
      window.location.assign(url);
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e || 'Request failed');
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto space-y-2 flex flex-col items-center mb-4">
      {!hideIntro ? (
        <p className="font-body text-sm text-secondary text-center leading-relaxed px-1">
          Subscribe with PayPal for full Pro access. £4.99/month. Cancel through your PayPal account or by{' '}
          <a href="mailto:mail@re-build-me.com" className="text-theme-accent underline underline-offset-2 hover:opacity-90">
            emailing us
          </a>
          {' '}
          at any time.
        </p>
      ) : null}
      <button
        type="button"
        disabled={busy}
        onClick={() => void onSubscribe()}
        className={subscribePrimaryButtonClass}
        data-testid="web-subscribe-paypal-btn"
      >
        {busy ? (
          <>
            <Loader2 className="h-4 w-4 shrink-0 animate-spin" aria-hidden />
            Connecting…
          </>
        ) : (
          'Subscribe with PayPal'
        )}
      </button>
    </div>
  );
}
